import React, { useEffect, useMemo, useState } from 'react'
import { adminRequest } from '../api/client'
import { Card, EmptyState, PageTitle, SearchField, StatusBadge, formatCurrency, formatDate } from '../components/Ui'

function budgetLabel(item) {
  if (item.budgetText) return item.budgetText
  if (item.budgetMin != null || item.budgetMax != null) return `${formatCurrency(item.budgetMin)} ~ ${formatCurrency(item.budgetMax)}`
  return '협의'
}

export default function QuoteRequests({ navigate }) {
  const [rows, setRows] = useState([])
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    let disposed = false
    adminRequest('/api/v1/admin/quote-requests')
      .then((response) => { if (!disposed) setRows(response?.data || []) })
      .catch((nextError) => { if (!disposed) setError(nextError?.message || '견적 요청을 불러오지 못했습니다.') })
      .finally(() => { if (!disposed) setLoading(false) })
    return () => { disposed = true }
  }, [])

  const statuses = useMemo(() => [...new Set(rows.map((item) => item.status).filter(Boolean))], [rows])
  const filtered = useMemo(() => rows.filter((item) => {
    const text = [item.requestNo, item.customerName, item.customerNickname, item.serviceName, item.region, item.originalRequest].join(' ').toLowerCase()
    return (!search || text.includes(search.toLowerCase())) && (status === 'ALL' || item.status === status)
  }), [rows, search, status])

  return (
    <>
      <PageTitle eyebrow="QUOTE REQUESTS · LIVE DB" title="견적 요청 관리" description="difan_dev의 고객 요청 원문, AI 분석 연결, 디렉터 전달·응답 상태를 확인합니다." />
      <Card className="table-card">
        <div className="table-toolbar">
          <SearchField value={search} onChange={setSearch} placeholder="요청번호, 고객, 서비스, 지역 검색" />
          <div className="filter-buttons">
            <button className={status === 'ALL' ? 'active' : ''} onClick={() => setStatus('ALL')}>전체</button>
            {statuses.map((value) => <button key={value} className={status === value ? 'active' : ''} onClick={() => setStatus(value)}>{value}</button>)}
          </div>
        </div>
        <div className="table-result-bar"><span>총 <strong>{filtered.length}</strong>건</span><small>source: PostgreSQL difan_dev</small></div>
        {loading ? <p className="help-copy">실제 견적 요청을 불러오는 중입니다.</p> : error ? <EmptyState title="견적 요청 조회 실패" description={error} /> : filtered.length === 0 ? <EmptyState title="표시할 견적 요청이 없습니다." description="회원이 등록한 실제 견적 요청이 이곳에 표시됩니다." /> : <div className="table-scroll"><table className="data-table"><thead><tr><th>요청번호</th><th>고객</th><th>서비스</th><th>지역</th><th>예산</th><th>전달/견적</th><th>첨부</th><th>상태</th><th>요청일</th><th /></tr></thead><tbody>{filtered.map((item) => <tr className="clickable-row" key={item.id} onClick={() => navigate(`/quote-requests/${item.id}`)}><td><strong>{item.requestNo}</strong></td><td><strong>{item.customerNickname || item.customerName || '-'}</strong><small>{item.customerName || '-'}</small></td><td><strong>{item.serviceName || '-'}</strong><small>{item.serviceSlug || '-'}</small></td><td>{item.region || '협의'}</td><td>{budgetLabel(item)}</td><td>{item.distributedDirectorCount || 0}명 / {item.quoteCount || 0}건</td><td>{item.attachmentCount || 0}개</td><td><StatusBadge status={item.status} /></td><td>{formatDate(item.createdAt, true)}</td><td><button className="row-arrow">›</button></td></tr>)}</tbody></table></div>}
      </Card>
    </>
  )
}
